import Backbone from 'backbone';
import { map, isEmpty } from 'lodash';

import CharacterAction from '../actions/action.js'

const equipment = Backbone.Model.extend({
  tagNames: function(){
    return map(this.get('tags'), function(tag) { return tag.name });
  },

  actions() {
    return map(this.get('character_actions'), (actionData) => {
      return new CharacterAction(actionData);
    })
  },

  protections() {
    return this.get('equipment_protections');
  },

  isWielded() {
    return !isEmpty(this.get('limb_count'));
  },

  isWorn() {
    return !isEmpty(this.get('body_part'));
  }
});

export default equipment;
